module.exports = __webpack_public_path__ + "img/status01.9a6d31d.png";